(function () {
  'use strict';

  var root = document.querySelector('[data-jm-catalog]');
  if (!root) return;

  var grid = root.querySelector('[data-jm-cat-grid]');
  var sheet = root.querySelector('[data-jm-cat-sheet]');
  var tableModal = root.querySelector('[data-jm-cat-table]');
  var search = root.querySelector('[data-jm-cat-search]');
  var searchForm = root.querySelector('[data-jm-cat-search-form]');
  var moreButton = root.querySelector('[data-jm-cat-more]');
  var emptyState = root.querySelector('[data-jm-cat-empty]');
  var visibleCount = root.querySelector('[data-jm-cat-visible-count]');
  var plural = root.querySelector('[data-jm-cat-count-plural]');
  var gallery = sheet.querySelector('[data-jm-cat-gallery]');
  var galleryPrevious = sheet.querySelector('[data-jm-cat-gallery-prev]');
  var galleryNext = sheet.querySelector('[data-jm-cat-gallery-next]');
  var galleryDots = sheet.querySelector('[data-jm-cat-gallery-dots]');
  var activeCard = null;
  var activeData = null;
  var activeColorIndex = 0;
  var activeGalleryIndex = 0;
  var activeVariant = null;
  var previousFocus = null;
  var knownGroups = Object.create(null);
  var knownAccessoryModels = Object.create(null);
  var whatsappNumber = root.getAttribute('data-whatsapp') || '';
  var storeName = root.getAttribute('data-shop') || '';
  var shareTitle = root.getAttribute('data-share-title') || '';
  var shareMessage = root.getAttribute('data-share-message') || '';
  var loadingMode = root.getAttribute('data-loading-mode') || 'button';
  var infiniteObserver = null;

  function safeJson(script) {
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('[JM Catálogo] Dados inválidos em um produto.', error);
      return null;
    }
  }

  function getCardData(card) {
    if (!card) return null;
    if (!card._jmCatalogData) {
      var script = card.querySelector('[data-jm-cat-data]');
      card._jmCatalogData = script ? safeJson(script) : null;
    }
    return card._jmCatalogData;
  }

  function moneyFromCents(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format((Number(value) || 0) / 100);
  }

  function normalizeList(value) {
    if (Array.isArray(value)) return value;
    if (value === null || typeof value === 'undefined' || value === '') return [];
    return String(value).split('|').map(function (item) { return item.trim(); });
  }

  function track(action, detail) {
    var payload = Object.assign({
      action: action,
      catalog: 'commercial',
      source: 'shopify_catalog',
      timestamp: new Date().toISOString(),
    }, detail || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'jm_catalog_interaction' }, payload));

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('jm_catalog_interaction', payload);
      }
    } catch (error) {
      /* O atendimento nunca deve falhar por causa da telemetria. */
    }
  }

  function updateCount() {
    if (!grid) return;
    var count = Array.prototype.filter.call(grid.querySelectorAll('[data-jm-cat-card]'), function (card) {
      return !card.hidden && !card.classList.contains('is-filtered');
    }).length;
    if (visibleCount) visibleCount.textContent = String(count);
    if (plural) plural.hidden = count === 1;
    if (emptyState) emptyState.hidden = count > 0;
  }

  var accessoryColorSuffixes = [
    'azul petróleo', 'azul serenity', 'amarelo creme', 'verde bandeira',
    'verde pistache', 'verde militar', 'verde água', 'rosa chiclete',
    'rosa fúcsia', 'rosa fucsia', 'rosa claro', 'rosa bebê', 'rosa bebe',
    'rosa blush', 'cinza chumbo', 'cinza escuro', 'cinza claro',
    'azul marinho', 'azul royal', 'azul claro', 'azul bebê', 'azul bebe',
    'off white', 'almost white', 'pink clay', 'bordô', 'bordo', 'marsala',
    'lavanda', 'violeta', 'turquesa', 'tiffany', 'fúcsia', 'fucsia',
    'lilás', 'lilas', 'vermelho', 'vermelha', 'amarelo', 'amarela',
    'laranja', 'marrom', 'cereja', 'goiaba', 'branco', 'branca', 'preto',
    'preta', 'rosé', 'rose', 'rosa', 'verde', 'azul', 'vinho', 'cinza',
    'bege', 'roxo', 'roxa', 'pink', 'nude', 'areia'
  ];

  function normalizedText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function accessoryModelTitle(value) {
    var title = String(value || '').replace(/\s+/g, ' ').trim();
    var normalized = normalizedText(title);
    var isAccessory = /^(touca\s+bandana|bandana|turbante|touca\s+elastico|faixa)\b/.test(normalized);
    if (!isAccessory) return null;

    for (var index = 0; index < accessoryColorSuffixes.length; index += 1) {
      var suffix = accessoryColorSuffixes[index];
      var normalizedSuffix = normalizedText(suffix);
      if (normalized === normalizedSuffix || normalized.slice(-(normalizedSuffix.length + 1)) === ' ' + normalizedSuffix) {
        return title.slice(0, title.length - suffix.length).replace(/[\s\-–—]+$/, '').trim();
      }
    }
    return title;
  }

  function accessoryModelKey(data) {
    if (!data) return null;
    var modelTitle = accessoryModelTitle(data.modelTitle);
    if (!modelTitle) return null;

    var original = normalizedText(data.modelTitle);
    var grouped = normalizedText(modelTitle);
    if (original === grouped && (!data.colors || data.colors.length < 2)) return null;
    return grouped;
  }

  function mergeUniqueColors(target, source) {
    if (!target || !source) return;
    target.colors = Array.isArray(target.colors) ? target.colors : [];
    (source.colors || []).forEach(function (color) {
      var exists = target.colors.some(function (current) {
        return String(current.id || current.handle) === String(color.id || color.handle);
      });
      if (!exists) target.colors.push(color);
    });
  }

  function renderCardColors(card) {
    var data = getCardData(card);
    var container = card && card.querySelector('.jm-cat-card__colors');
    if (!data || !container || !data.colors || !data.colors.length) return;

    if (data.colors.length < 2) {
      container.setAttribute('aria-label', '1 cor disponível');
      container.innerHTML = '<span class="jm-cat-card__single">Ver detalhes</span>';
      return;
    }

    container.setAttribute('aria-label', data.colors.length + ' cores disponíveis');
    container.innerHTML = data.colors.slice(0, 7).map(function (color, index) {
      var image = color.featuredImage && (color.featuredImage.thumb || color.featuredImage.src);
      return '<button type="button" class="' + (index === 0 ? 'is-selected' : '') +
        '" data-jm-cat-card-color="' + index + '" aria-label="' +
        escapeAttribute(color.title || color.color) + '" aria-pressed="' +
        (index === 0 ? 'true' : 'false') + '">' +
        (image ? '<img src="' + escapeAttribute(image) + '" alt="" loading="lazy">' : '') +
        '</button>';
    }).join('') + (data.colors.length > 7 ? '<span>+' + (data.colors.length - 7) + '</span>' : '');
  }

  function consolidateAccessoryCard(card, data) {
    var key = accessoryModelKey(data);
    if (!key) return false;

    var modelTitle = accessoryModelTitle(data.modelTitle);
    var canonical = knownAccessoryModels[key];
    if (canonical && canonical !== card) {
      var canonicalData = getCardData(canonical);
      mergeUniqueColors(canonicalData, data);
      canonicalData.modelTitle = modelTitle;
      renderCardColors(canonical);
      var canonicalTitle = canonical.querySelector('.jm-cat-card__copy strong');
      var canonicalOpen = canonical.querySelector('[data-jm-cat-open]');
      if (canonicalTitle) canonicalTitle.textContent = modelTitle;
      if (canonicalOpen) canonicalOpen.setAttribute('aria-label', 'Ver ' + modelTitle);
      var canonicalSearch = canonical.getAttribute('data-search') || '';
      var incomingSearch = card.getAttribute('data-search') || '';
      canonical.setAttribute('data-search', (canonicalSearch + ' ' + incomingSearch).trim());
      card.hidden = true;
      return true;
    }

    knownAccessoryModels[key] = card;
    if (data.colors && data.colors.length > 1) {
      data.modelTitle = modelTitle;
      var title = card.querySelector('.jm-cat-card__copy strong');
      var open = card.querySelector('[data-jm-cat-open]');
      if (title) title.textContent = modelTitle;
      if (open) open.setAttribute('aria-label', 'Ver ' + modelTitle);
      renderCardColors(card);
    }
    return false;
  }

  function registerCards(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-jm-cat-card]').forEach(function (card) {
      var data = getCardData(card);
      if (consolidateAccessoryCard(card, data)) return;
      var groupId = data && data.groupId ? String(data.groupId) : card.getAttribute('data-group-id');
      if (groupId && knownGroups[groupId] && knownGroups[groupId] !== card) {
        card.hidden = true;
        return;
      }
      if (groupId) knownGroups[groupId] = card;
      card._jmColorIndex = 0;
    });
    updateCount();
  }

  function updateCardColor(card, index) {
    var data = getCardData(card);
    if (!data || !data.colors || !data.colors[index]) return;
    var color = data.colors[index];
    var image = card.querySelector('[data-jm-cat-card-image]');
    var price = card.querySelector('[data-jm-cat-card-price]');
    var compare = card.querySelector('[data-jm-cat-card-compare]');
    var installments = card.querySelector('[data-jm-cat-card-installments]');

    card._jmColorIndex = index;
    card.querySelectorAll('[data-jm-cat-card-color]').forEach(function (button) {
      var selected = Number(button.getAttribute('data-jm-cat-card-color')) === index;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    if (image && color.featuredImage && color.featuredImage.src) {
      image.style.opacity = '.45';
      var preload = new Image();
      preload.onload = function () {
        image.src = color.featuredImage.src;
        image.srcset = '';
        image.alt = color.featuredImage.alt || color.title;
        image.style.opacity = '';
      };
      preload.src = color.featuredImage.src;
    }
    if (price) price.textContent = color.priceFormatted || moneyFromCents(color.price);
    if (installments) installments.textContent = '6x de ' + moneyFromCents(Number(color.price) / 6) + ' sem juros';
    if (compare) {
      var hasCompare = Number(color.compareAtPrice) > Number(color.price);
      compare.textContent = hasCompare ? (color.compareAtPriceFormatted || moneyFromCents(color.compareAtPrice)) : '';
      compare.hidden = !hasCompare;
    }
  }

  function colorAt(index) {
    if (!activeData || !activeData.colors || !activeData.colors.length) return null;
    return activeData.colors[index] || activeData.colors[0];
  }

  function variantOption(variant, position) {
    return variant['option' + position] || variant.title || '';
  }

  function uniqueSizes(color) {
    if (!color || !color.variants || !color.variants.length || !color.sizePosition) return [];
    var sizes = [];
    color.variants.forEach(function (variant) {
      var name = variantOption(variant, color.sizePosition);
      if (!name || name === 'Default Title') return;
      var existing = sizes.find(function (item) { return item.name === name; });
      if (!existing) {
        existing = { name: name, available: false, variants: [] };
        sizes.push(existing);
      }
      existing.variants.push(variant);
      if (variant.available) existing.available = true;
    });
    return sizes;
  }

  function galleryMarkup(color) {
    var images = color.images && color.images.length ? color.images : [];
    if (!images.length && color.featuredImage && color.featuredImage.src) {
      images = [color.featuredImage];
    }
    return images.map(function (image, index) {
      return '<figure><img src="' + escapeAttribute(image.src) + '" alt="' +
        escapeAttribute(image.alt || color.title) + '" loading="' + (index ? 'lazy' : 'eager') +
        '" draggable="false"></figure>';
    }).join('');
  }

  function escapeAttribute(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function renderColors() {
    var container = sheet.querySelector('[data-jm-cat-colors]');
    if (!container) return;
    container.innerHTML = activeData.colors.map(function (color, index) {
      var image = color.featuredImage && (color.featuredImage.thumb || color.featuredImage.src);
      return '<button type="button" data-jm-sheet-color="' + index + '" class="' +
        (index === activeColorIndex ? 'is-selected' : '') + '" aria-pressed="' +
        (index === activeColorIndex ? 'true' : 'false') + '" aria-label="Cor ' +
        escapeAttribute(color.color) + '" title="' + escapeAttribute(color.color) + '">' +
        (image ? '<img src="' + escapeAttribute(image) + '" alt="" loading="lazy">' : '') +
        '</button>';
    }).join('');
  }

  function galleryItems() {
    return gallery ? gallery.querySelectorAll('figure') : [];
  }

  function updateGalleryControls(index) {
    var total = galleryItems().length;
    activeGalleryIndex = Math.max(0, Math.min(Number(index) || 0, Math.max(0, total - 1)));
    var hasMultiple = total > 1;

    if (galleryPrevious) {
      galleryPrevious.hidden = !hasMultiple;
      galleryPrevious.disabled = activeGalleryIndex === 0;
    }
    if (galleryNext) {
      galleryNext.hidden = !hasMultiple;
      galleryNext.disabled = activeGalleryIndex >= total - 1;
    }
    if (galleryDots) {
      galleryDots.hidden = !hasMultiple;
      galleryDots.querySelectorAll('button').forEach(function (button, dotIndex) {
        var selected = dotIndex === activeGalleryIndex;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-current', selected ? 'true' : 'false');
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }
  }

  function goToGalleryImage(index, smooth) {
    var total = galleryItems().length;
    if (!gallery || !total) return;
    var nextIndex = Math.max(0, Math.min(Number(index) || 0, total - 1));
    gallery.scrollTo({
      left: nextIndex * gallery.clientWidth,
      behavior: smooth ? 'smooth' : 'auto',
    });
    updateGalleryControls(nextIndex);
  }

  function renderGallery(color) {
    if (!gallery) return;
    gallery.innerHTML = galleryMarkup(color);
    var total = galleryItems().length;
    activeGalleryIndex = 0;
    gallery.scrollLeft = 0;
    if (galleryDots) {
      galleryDots.innerHTML = Array.from({ length: total }, function (_, index) {
        return '<button type="button" data-jm-gallery-dot="' + index +
          '" aria-label="Ver foto ' + (index + 1) + '"></button>';
      }).join('');
    }
    gallery.onscroll = function () {
      if (!gallery.clientWidth) return;
      window.requestAnimationFrame(function () {
        updateGalleryControls(Math.round(gallery.scrollLeft / gallery.clientWidth));
      });
    };
    updateGalleryControls(0);
  }

  function updateDisplayedPrice(color) {
    var price = activeVariant && activeVariant.price ? activeVariant.price : color.price;
    sheet.querySelector('[data-jm-cat-price]').textContent =
      activeVariant && activeVariant.priceFormatted
        ? activeVariant.priceFormatted
        : (color.priceFormatted || moneyFromCents(price));

    var compare = sheet.querySelector('[data-jm-cat-compare]');
    var hasCompare = Number(color.compareAtPrice) > Number(price);
    compare.textContent = hasCompare ? (color.compareAtPriceFormatted || moneyFromCents(color.compareAtPrice)) : '';
    compare.hidden = !hasCompare;

    var installments = sheet.querySelector('[data-jm-cat-installments]');
    if (installments) {
      installments.textContent = 'ou 6x de ' + moneyFromCents(Number(price) / 6) + ' sem juros';
    }
  }

  function renderSizes(color) {
    var wrap = sheet.querySelector('[data-jm-cat-size-wrap]');
    var container = sheet.querySelector('[data-jm-cat-sizes]');
    var status = sheet.querySelector('[data-jm-cat-size-status]');
    var sizes = uniqueSizes(color);
    activeVariant = null;

    if (!sizes.length) {
      wrap.hidden = true;
      activeVariant = color.variants && color.variants.find(function (variant) { return variant.available; }) || null;
      return;
    }

    wrap.hidden = false;
    status.textContent = 'Escolha uma opção';
    container.innerHTML = sizes.map(function (size) {
      return '<button type="button" data-jm-sheet-size="' + escapeAttribute(size.name) + '"' +
        (size.available ? '' : ' disabled') + '>' + escapeAttribute(size.name) + '</button>';
    }).join('');
  }

  function updateTools(color) {
    var chartButton = sheet.querySelector('[data-jm-cat-chart]');
    var fitterButton = sheet.querySelector('[data-jm-cat-fitter]');
    var available = !!(color.chart && color.chart.available);
    chartButton.hidden = !available;
    fitterButton.hidden = !available;
    sheet.querySelector('[data-jm-cat-tools]').hidden = !available;
  }

  function updateWhatsapp(color) {
    var link = sheet.querySelector('[data-jm-cat-whatsapp]');
    var hint = sheet.querySelector('[data-jm-cat-hint]');
    var requiresSize = uniqueSizes(color).length > 0;
    var ready = !!whatsappNumber && !!color.available && (!requiresSize || !!activeVariant);

    if (!whatsappNumber) {
      hint.textContent = 'O WhatsApp de atendimento ainda não foi configurado.';
    } else if (!color.available) {
      hint.textContent = 'Este modelo está indisponível no momento.';
    } else if (requiresSize && !activeVariant) {
      hint.textContent = 'Selecione o tamanho para conversar com uma consultora.';
    } else {
      hint.textContent = 'Tudo certo. Sua escolha será enviada pronta para a consultora.';
    }

    link.classList.toggle('is-disabled', !ready);
    link.setAttribute('aria-disabled', ready ? 'false' : 'true');
    if (!ready) {
      link.href = '#';
      return;
    }

    var size = requiresSize ? variantOption(activeVariant, color.sizePosition) : 'a confirmar';
    var productUrl = new URL(color.url, window.location.origin).href;
    var message = 'Olá! Tenho interesse no ' + activeData.modelTitle +
      ', cor ' + color.color + ', tamanho ' + size +
      '. Vi no catálogo da ' + storeName + '. Pode me ajudar?\n\n' + productUrl;
    link.href = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(message);
  }

  function renderColor(index) {
    var color = colorAt(index);
    if (!color) return;
    activeColorIndex = index;
    renderGallery(color);
    renderColors();
    renderSizes(color);
    updateDisplayedPrice(color);
    updateTools(color);
    updateWhatsapp(color);
  }

  function openSheet(card) {
    var data = getCardData(card);
    if (!data || !data.colors || !data.colors.length) return;
    previousFocus = document.activeElement;
    activeCard = card;
    activeData = data;
    activeColorIndex = Number(card._jmColorIndex) || 0;
    sheet.querySelector('[data-jm-cat-title]').textContent = data.modelTitle;
    renderColor(activeColorIndex);
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jm-cat-lock');
    sheet.querySelector('[data-jm-cat-sheet-close]').focus();
    track('view_model', {
      product_group_id: data.groupId,
      product_name: data.modelTitle,
      color: colorAt(activeColorIndex).color,
    });
  }

  function closeSheet() {
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (!tableModal.classList.contains('is-open')) document.body.classList.remove('jm-cat-lock');
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function openTable(color) {
    if (!color || !color.chart || !color.chart.available) return;
    var columns = normalizeList(color.chart.columns);
    var rows = normalizeList(color.chart.rows);
    var table = '<table><thead><tr><th scope="col">Medidas</th>';
    columns.forEach(function (column) {
      table += '<th scope="col">' + escapeAttribute(column) + '</th>';
    });
    table += '</tr></thead><tbody>';
    rows.forEach(function (row) {
      var cells = Array.isArray(row) ? row : String(row).split('|');
      table += '<tr>';
      var measure = String(cells[0] || '').trim();
      var unit = String(cells[1] || '').trim();
      table += '<th scope="row">' + escapeAttribute(measure) +
        (unit ? ' <small>' + escapeAttribute(unit) + '</small>' : '') + '</th>';
      cells.slice(2).forEach(function (cell) {
        table += '<td>' + escapeAttribute(String(cell).trim()) + '</td>';
      });
      table += '</tr>';
    });
    table += '</tbody></table>';
    tableModal.querySelector('[data-jm-cat-table-content]').innerHTML = table;
    tableModal.classList.add('is-open');
    tableModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jm-cat-lock');
    tableModal.querySelector('[data-jm-cat-table-close]').focus();
    track('open_size_chart', {
      product_group_id: activeData.groupId,
      product_name: activeData.modelTitle,
      color: color.color,
    });
  }

  function closeTable() {
    tableModal.classList.remove('is-open');
    tableModal.setAttribute('aria-hidden', 'true');
    if (!sheet.classList.contains('is-open')) document.body.classList.remove('jm-cat-lock');
  }

  function filterCards() {
    if (!grid || !search) return;
    var query = search.value.trim().toLowerCase();
    searchForm.classList.toggle('has-value', !!query);
    grid.querySelectorAll('[data-jm-cat-card]').forEach(function (card) {
      if (card.hidden) return;
      var haystack = (card.getAttribute('data-search') || '').toLowerCase();
      card.classList.toggle('is-filtered', !!query && haystack.indexOf(query) === -1);
    });
    updateCount();
  }

  function clearSearch() {
    if (!search) return;
    search.value = '';
    filterCards();
    search.focus();
  }

  function syncNavigationFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var requestedGender = params.get('genero') || root.getAttribute('data-current-gender') || 'feminino';
    var requestedCategory = params.get('categoria');
    var genderButton = root.querySelector('[data-jm-cat-gender="' + requestedGender + '"]');
    if (!genderButton) return;

    root.querySelectorAll('[data-jm-cat-gender]').forEach(function (button) {
      var selected = button === genderButton;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    root.querySelectorAll('.jm-cat__categories a').forEach(function (anchor) {
      var categoryMatch = anchor.href.match(/[?&]categoria=([^&]+)/);
      var category = categoryMatch ? decodeURIComponent(categoryMatch[1]) : '';
      var target = genderButton.getAttribute('data-' + category);
      if (target) anchor.href = target;
      if (requestedCategory) anchor.classList.toggle('is-active', category === requestedCategory);
    });
  }

  async function loadMore() {
    if (!moreButton || !moreButton.dataset.nextUrl || moreButton.classList.contains('is-loading')) return;
    var loadFailed = false;
    moreButton.classList.add('is-loading');
    moreButton.querySelector('span').textContent = 'Carregando';
    try {
      var response = await fetch(moreButton.dataset.nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      var documentFragment = new DOMParser().parseFromString(html, 'text/html');
      var nextGrid = documentFragment.querySelector('[data-jm-cat-grid]');
      var nextButton = documentFragment.querySelector('[data-jm-cat-more]');
      if (nextGrid) {
        Array.from(nextGrid.children).forEach(function (card) {
          grid.appendChild(card);
        });
        registerCards(grid);
        filterCards();
      }
      moreButton.dataset.nextUrl = nextButton ? nextButton.dataset.nextUrl || '' : '';
      moreButton.hidden = !moreButton.dataset.nextUrl;
      if (moreButton.hidden) moreButton.setAttribute('aria-hidden', 'true');
      else moreButton.removeAttribute('aria-hidden');
    } catch (error) {
      loadFailed = true;
      moreButton.querySelector('span').textContent = 'Tentar novamente';
      loadingMode = 'button';
      root.setAttribute('data-loading-mode', 'button');
      moreButton.removeAttribute('tabindex');
      if (infiniteObserver) infiniteObserver.disconnect();
      console.error('[JM Catálogo] Não foi possível carregar mais produtos.', error);
      return;
    } finally {
      moreButton.classList.remove('is-loading');
      if (moreButton.querySelector('span').textContent === 'Carregando') {
        moreButton.querySelector('span').textContent = 'Ver mais modelos';
      }
      if (!loadFailed && infiniteObserver && !moreButton.hidden) {
        infiniteObserver.unobserve(moreButton);
        window.requestAnimationFrame(function () {
          infiniteObserver.observe(moreButton);
        });
      }
    }
  }

  function initializeInfiniteLoading() {
    if (loadingMode !== 'infinite' || !moreButton || !moreButton.dataset.nextUrl) return;
    if (!('IntersectionObserver' in window)) {
      loadingMode = 'button';
      root.setAttribute('data-loading-mode', 'button');
      moreButton.removeAttribute('tabindex');
      return;
    }

    infiniteObserver = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) loadMore();
    }, {
      rootMargin: '700px 0px',
      threshold: 0,
    });
    infiniteObserver.observe(moreButton);
  }

  root.addEventListener('click', function (event) {
    var cardColor = event.target.closest('[data-jm-cat-card-color]');
    if (cardColor) {
      event.preventDefault();
      event.stopPropagation();
      updateCardColor(cardColor.closest('[data-jm-cat-card]'), Number(cardColor.dataset.jmCatCardColor));
      return;
    }

    var cardOpen = event.target.closest('[data-jm-cat-open]');
    if (cardOpen) {
      openSheet(cardOpen.closest('[data-jm-cat-card]'));
      return;
    }

    if (event.target.closest('[data-jm-cat-sheet-close]')) {
      closeSheet();
      return;
    }

    if (event.target.closest('[data-jm-cat-table-close]')) {
      closeTable();
      return;
    }

    var sheetColor = event.target.closest('[data-jm-sheet-color]');
    if (sheetColor) {
      renderColor(Number(sheetColor.dataset.jmSheetColor));
      return;
    }

    var sheetSize = event.target.closest('[data-jm-sheet-size]');
    if (sheetSize) {
      var color = colorAt(activeColorIndex);
      var size = sheetSize.dataset.jmSheetSize;
      activeVariant = color.variants.find(function (variant) {
        return variant.available && variantOption(variant, color.sizePosition) === size;
      }) || null;
      sheet.querySelectorAll('[data-jm-sheet-size]').forEach(function (button) {
        button.classList.toggle('is-selected', button === sheetSize);
      });
      sheet.querySelector('[data-jm-cat-size-status]').textContent = activeVariant ? size + ' selecionado' : 'Indisponível';
      updateDisplayedPrice(color);
      updateWhatsapp(color);
      track('select_size', {
        product_group_id: activeData.groupId,
        product_name: activeData.modelTitle,
        product_id: color.id,
        variant_id: activeVariant && activeVariant.id,
        color: color.color,
        size: size,
      });
      return;
    }

    if (event.target.closest('[data-jm-cat-gallery-prev]')) {
      goToGalleryImage(activeGalleryIndex - 1, true);
      return;
    }

    if (event.target.closest('[data-jm-cat-gallery-next]')) {
      goToGalleryImage(activeGalleryIndex + 1, true);
      return;
    }

    var galleryDot = event.target.closest('[data-jm-gallery-dot]');
    if (galleryDot) {
      goToGalleryImage(Number(galleryDot.dataset.jmGalleryDot), true);
      return;
    }

    if (event.target.closest('[data-jm-cat-chart]')) {
      openTable(colorAt(activeColorIndex));
      return;
    }

    if (event.target.closest('[data-jm-cat-fitter]')) {
      var fitterColor = colorAt(activeColorIndex);
      if (window.JMProvador && fitterColor.chart && fitterColor.chart.available) {
        window.JMProvador.open(fitterColor.chart);
        track('open_virtual_fitter', {
          product_group_id: activeData.groupId,
          product_name: activeData.modelTitle,
          color: fitterColor.color,
        });
      }
      return;
    }

    var whatsapp = event.target.closest('[data-jm-cat-whatsapp]');
    if (whatsapp && !whatsapp.classList.contains('is-disabled')) {
      var selectedColor = colorAt(activeColorIndex);
      track('whatsapp_consultant', {
        product_group_id: activeData.groupId,
        product_name: activeData.modelTitle,
        product_id: selectedColor.id,
        variant_id: activeVariant && activeVariant.id,
        color: selectedColor.color,
        size: activeVariant ? variantOption(activeVariant, selectedColor.sizePosition) : null,
        value: Number(activeVariant ? activeVariant.price : selectedColor.price) / 100,
        currency: 'BRL',
      });
      return;
    }

    var gender = event.target.closest('[data-jm-cat-gender]');
    if (gender) {
      var params = new URLSearchParams(window.location.search);
      var category = params.get('categoria') || 'jalecos';
      var url = gender.getAttribute('data-' + category) || gender.getAttribute('data-jalecos');
      if (url) window.location.href = url;
      return;
    }

    if (event.target.closest('[data-jm-cat-search-clear]') || event.target.closest('[data-jm-cat-empty-clear]')) {
      clearSearch();
      return;
    }

    if (event.target.closest('[data-jm-cat-more]')) {
      loadMore();
      return;
    }

    if (event.target.closest('[data-jm-cat-share]')) {
      var shareUrl = window.location.href;
      var shareData = {
        title: shareTitle || document.title,
        text: shareMessage,
        url: shareUrl,
      };
      if (navigator.share) {
        navigator.share(shareData).catch(function () {});
      } else if (navigator.clipboard) {
        var clipboardText = [shareData.text, shareData.url].filter(Boolean).join('\n');
        navigator.clipboard.writeText(clipboardText).then(function () {
          var label = root.querySelector('[data-jm-cat-share] span');
          if (!label) return;
          var original = label.textContent;
          label.textContent = 'Link copiado';
          window.setTimeout(function () { label.textContent = original; }, 1800);
        });
      }
      track('share_catalog', { url: shareUrl });
    }
  });

  if (search) {
    search.addEventListener('input', filterCards);
    search.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') clearSearch();
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      if (!search.value.trim()) event.preventDefault();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (tableModal.classList.contains('is-open')) closeTable();
    else if (sheet.classList.contains('is-open')) closeSheet();
  });

  registerCards(grid);
  syncNavigationFromUrl();
  filterCards();
  initializeInfiniteLoading();
})();
